import { render } from "./ProposalDetailsForm.vue?vue&type=template&id=412d8bf8&scoped=true"
import script from "./ProposalDetailsForm.vue?vue&type=script&lang=js"
export * from "./ProposalDetailsForm.vue?vue&type=script&lang=js"

import "./ProposalDetailsForm.vue?vue&type=style&index=0&id=412d8bf8&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412d8bf8"]])

export default __exports__